var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.app.platformCode === 'fabric')?_c('p',[_c('FabricLogo',{attrs:{"color":_vm.color}})],1):_c('p',[_c('RevCascadeLogo')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }